/**
 * Appends pre-encoded query parts to a URL that may already contain a query
 * string. Deterministic for trailing `?` / `&` to avoid producing `??` / `&&`.
 *
 * @param {string} url
 * @param {string[]} parts - Each entry is an already-encoded `key=value` pair.
 * @returns {string}
 */
export function buildOptionsUrl(url, parts) {
  if (parts.length === 0) return url;
  const suffix = parts.join('&');
  if (url.endsWith('?') || url.endsWith('&')) return `${url}${suffix}`;
  return `${url}${url.includes('?') ? '&' : '?'}${suffix}`;
}
